import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";
import { busca_media_disciplina_ciclo } from "../../services/api";
import { ConverteSerie, ConverteSegmentoSig, ordem } from "./modulo";

const Media_ciclo_disciplina = (props) => {
    const [data2, setData2] = useState([]);
    const [avaliacao, setAvaliacao] = useState('AS1');
    const [serie, setSerie] = useState('1-1');

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];

    let cod_unidade = props.un;

    // Lista de opções para os ComboBoxes
    const avaliacaoOptions = ['AS1', 'AS2', 'AS3', 'AS4'];
    const serieOptions = [
        { value: '1-1', label: '1º Fund I' },
        { value: '1-2', label: '2º Fund I' },
        { value: '1-3', label: '3º Fund I' },
        { value: '1-4', label: '4º Fund I' },
        { value: '1-5', label: '5º Fund I' },
        { value: '1-6', label: '6º Fund II' },
        { value: '1-7', label: '7º Fund II' },
        { value: '1-8', label: '8º Fund II' },
        { value: '1-9', label: '9º Fund II' },
        { value: '2-1', label: '1ª Médio' },
        { value: '2-2', label: '2ª Médio' },
        { value: '2-3', label: '3ª Médio' },
    ];

    const fetchData = async () => {
        try {
            const response = await busca_media_disciplina_ciclo(cod_unidade, serie);
            console.log("RES=", response);
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [serie]);

    let chartDatSerie = [];

    let data2Filter = data2.filter(item => item.unidade === cod_unidade);

    console.log('data2Filter', data2Filter)

    if (typeof data2Filter !== 'undefined') {
        chartDatSerie = data2Filter.map((item, index) => {
            const row = [ConverteSerie(item.segmento)];
            row.push(item.turma);
            row.push(item.disciplina);
            row.push(item.mc1);
            row.push(item.mc2);
            row.push(item.mc3);
            row.push(item.mc4);
            return row;

        });
    };


    //chartDatSerie.sort();
    chartDatSerie.unshift(["Segmento", "Turma", "Disciplina", "M. Ciclo 1", "M. Ciclo 2", "M. Ciclo 3", "M. Ciclo 4"]);

    const options = {
        allowHtml: true,
    };

    const formatters = [
        {
            type: "ColorFormat",
            column: 3,
            ranges: [
                [0, 17.5, "red", "white"],
                [17.5, 25, "blue", "white"],
            ],
        },
        {
            type: "ColorFormat",
            column: 4,
            ranges: [
                [0, 17.5, "red", "white"],
                [17.5, 25, "blue", "white"],
            ],
        },
        {
            type: "ColorFormat",
            column: 5,
            ranges: [
                [0, 17.5, "red", "white"],
                [17.5, 25, "blue", "white"],
            ],
        },
        {
            type: "ColorFormat",
            column: 6,
            ranges: [
                [0, 17.5, "red", "white"],
                [17.5, 25, "blue", "white"],
            ],
        },
    ];


    return (
        <div className="Média_somatorio_ciclo" style={{ border: "1px solid #ccc", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "20px", borderRadius: "8px" }}>
            <center>
                <h5><b>
                    Média do Somatório de notas por Ciclo e Disciplina
                </b>
                </h5>
            </center>

            <br />
            <label>
                Série:
                <select value={serie} onChange={(e) => setSerie(e.target.value)}>
                    {serieOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </label>
            <br />
            <br />
            <Chart
                chartType="Table"
                width="100%"
                data={chartDatSerie}
                options={options}
                formatters={formatters}
            />
        </div>
    );
};

export default Media_ciclo_disciplina;
